export enum AvailableLanguages {
  EN = 'en',
  DE = 'de',
}

export type PageLanguage = {
  language: AvailableLanguages;
  slug: string;
};
